import iconsUrl from './icons.svg';

const SIZES = { sm: 16, md: 24, lg: 32 };

export default function Icon({ name, size = 'md', color, style, ...rest }) {
  const px = SIZES[size] || SIZES.md;
  return (
    <svg
      width={px}
      height={px}
      aria-hidden={!rest['aria-label']}
      style={{ color, display: 'inline-block', flexShrink: 0, ...style }}
      {...rest}
    >
      <use href={`${iconsUrl}#icon-${name}`} />
    </svg>
  );
}
